// extracted by mini-css-extract-plugin
module.exports = {"wrap":"google_wrap__2wc6e","btn":"google_btn__26VIh"};